// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json = require("../Json.bs.js");
var Curry = require("bs-platform/lib/js/curry.js");
var TypeUtils = require("../types/TypeUtils.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var StringUtils = require("../StringUtils.bs.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Float = require("relude/src/Relude_Float.bs.js");
var Relude_Js_Exn = require("relude/src/js/Relude_Js_Exn.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_String = require("relude/src/Relude_String.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var Js_null_undefined = require("bs-platform/lib/js/js_null_undefined.js");
var StripeTypes_Utils = require("./StripeTypes_Utils.bs.js");

function fromRawError(rawError) {
  switch (rawError.type) {
    case "StripeAPIError" :
        return {
                TAG: /* APIError */2,
                _0: rawError
              };
    case "StripeAuthenticationError" :
        return {
                TAG: /* AuthenticationError */4,
                _0: rawError
              };
    case "StripeCardError" :
        return {
                TAG: /* CardError */0,
                _0: rawError
              };
    case "StripeConnectionError" :
        return {
                TAG: /* ConnectionError */3,
                _0: rawError
              };
    case "StripeIdempotencyError" :
        return {
                TAG: /* IdempotencyError */7,
                _0: rawError
              };
    case "StripeInvalidGrantError" :
        return {
                TAG: /* InvalidGrantError */8,
                _0: rawError
              };
    case "StripeInvalidRequestError" :
        return {
                TAG: /* InvalidRequestError */1,
                _0: rawError
              };
    case "StripePermissionError" :
        return {
                TAG: /* PermissionError */6,
                _0: rawError
              };
    case "StripeRateLimitError" :
        return {
                TAG: /* RateLimitError */5,
                _0: rawError
              };
    default:
      return {
              TAG: /* Unknown */9,
              _0: rawError
            };
  }
}

function getMessage(param) {
  return param._0.message;
}

function toJsExn(param) {
  return Relude_Globals.$great$great(getMessage, Relude_Js_Exn.make, param);
}

var $$Error = {
  fromRawError: fromRawError,
  getMessage: getMessage,
  toJsExn: toJsExn
};

function fromString(str) {
  if (str.startsWith("sk_")) {
    return str;
  }
  
}

var include = TypeUtils.MakeCustomOpaqueStringType({
      fromString: fromString,
      toString: Relude_Globals.id
    });

var Key = include;

function fromString$1(str) {
  if (str.startsWith("pk_")) {
    return str;
  }
  
}

var include$1 = TypeUtils.MakeCustomOpaqueStringType({
      fromString: fromString$1,
      toString: Relude_Globals.id
    });

var PublicKey = include$1;

var _map = {"usd":"usd"};

function currencyToJs(param) {
  return param;
}

function currencyFromJs(param) {
  return _map[param];
}

function currencyFromJs$1(param) {
  return Relude_Globals.$great$great(Relude_String.toLowerCase, currencyFromJs, param);
}

var _map$1 = {"pending":"pending","paid":"paid","failed":"failed","canceled":"canceled"};

function payoutStatusToJs(param) {
  return param;
}

function payoutStatusFromJs(param) {
  return _map$1[param];
}

function payoutStatusFromJs$1(param) {
  return Relude_Globals.$great$great(Relude_String.toLowerCase, payoutStatusFromJs, param);
}

var _map$2 = {"instant":"instant","standard":"standard"};

function tToJs(param) {
  return param;
}

function tFromJs(param) {
  return _map$2[param];
}

function tFromJs$1(param) {
  return Relude_Globals.$great$great(Relude_String.toLowerCase, tFromJs, param);
}

function decode(json) {
  return Curry._2(Json.Decode.$great$great$eq, Curry._2(Json.Decode.$less$$great, tFromJs$1, Curry._1(Json.Decode.string, json)), Curry._1(Json.Decode.ResultUtil.note, {
                  TAG: /* Val */0,
                  _0: "ExpectedValidOption",
                  _1: json
                }));
}

function getInstantTransferFeeInCentsForPayout(paymentMethod, workerPayoutInCents) {
  if (paymentMethod === "instant") {
    return Curry._2(Relude_Float.max, workerPayoutInCents * 0.03, 50.0);
  } else {
    return 0.0;
  }
}

var PayoutMethod = {
  tToJs: tToJs,
  tFromJs: tFromJs$1,
  decode: decode,
  minimumInstantTransferFeeInCents: 50.0,
  instantPaymentFeePercentage: 0.03,
  getInstantTransferFeeInCentsForPayout: getInstantTransferFeeInCentsForPayout
};

var partial_arg = Curry._1(Relude_Array.map, tFromJs$1);

function availablePayoutMethodsGet(param) {
  return Relude_Globals.$great$great((function (prim) {
                return prim.available_payout_methods;
              }), partial_arg, param);
}

function make(id, availablePayoutMethods) {
  return {
          id: id,
          available_payout_methods: Curry._2(Relude_Array.map, tToJs, availablePayoutMethods)
        };
}

var partial_arg$1 = Curry._1(Relude_Array.find, (function (method_) {
        if (method_ !== undefined) {
          return method_ === "instant";
        } else {
          return false;
        }
      }));

function partial_arg$2(param) {
  return Relude_Globals.$great$great(availablePayoutMethodsGet, partial_arg$1, param);
}

function hasInstantPay(param) {
  return Relude_Globals.$great$great(partial_arg$2, Relude_Option.isSome, param);
}

var ExternalAccount = {
  availablePayoutMethodsGet: availablePayoutMethodsGet,
  make: make,
  hasInstantPay: hasInstantPay
};

var partial_arg$3 = Curry._1(Relude_Option.flatMap, (function (prim) {
        if (prim == null) {
          return ;
        } else {
          return Caml_option.some(prim);
        }
      }));

function partial_arg$4(param) {
  return Relude_Globals.$great$great((function (prim) {
                return Caml_option.undefined_to_opt(prim.current_deadline);
              }), partial_arg$3, param);
}

function currentDeadlineGet(param) {
  return Relude_Globals.$great$great(partial_arg$4, (function (param) {
                return Relude_Option.map(StripeTypes_Utils.floatToDate, param);
              }), param);
}

function disabledReasonGet(param) {
  return Relude_Globals.$great$great((function (prim) {
                return prim.disabled_reason;
              }), (function (prim) {
                if (prim == null) {
                  return ;
                } else {
                  return Caml_option.some(prim);
                }
              }), param);
}

function make$1(currentDeadline, disabledReason) {
  var arg = Js_null_undefined.fromOption(disabledReason);
  return function (param) {
    var partial_arg = Relude_Option.map((function (param) {
            return Relude_Globals.$great$great(StripeTypes_Utils.dateToFloat, (function (prim) {
                          return prim;
                        }), param);
          }), currentDeadline);
    return function (param$1, param$2, param$3, param$4) {
      var tmp = {
        currently_due: param,
        disabled_reason: arg,
        eventually_due: param$1,
        past_due: param$2,
        pending_verification: param$3
      };
      if (partial_arg !== undefined) {
        tmp.current_deadline = Caml_option.valFromOption(partial_arg);
      }
      return tmp;
    };
  };
}

var Requirements = {
  currentDeadlineGet: currentDeadlineGet,
  disabledReasonGet: disabledReasonGet,
  make: make$1
};

function disabledReasonGet$1(param) {
  return Relude_Globals.$great$great((function (prim) {
                return prim.disabled_reason;
              }), (function (prim) {
                if (prim == null) {
                  return ;
                } else {
                  return Caml_option.some(prim);
                }
              }), param);
}

function dueByGet(param) {
  return Relude_Globals.$great$great((function (param) {
                return Relude_Globals.$great$great((function (prim) {
                              return prim.due_by;
                            }), (function (prim) {
                              if (prim == null) {
                                return ;
                              } else {
                                return Caml_option.some(prim);
                              }
                            }), param);
              }), (function (param) {
                return Relude_Option.map(StripeTypes_Utils.floatToDate, param);
              }), param);
}

function make$2(dueBy, disabledReason, fieldsNeeded, param) {
  return {
          disabled_reason: Js_null_undefined.fromOption(disabledReason),
          due_by: Js_null_undefined.fromOption(Relude_Option.map(StripeTypes_Utils.dateToFloat, dueBy)),
          fields_needed: fieldsNeeded
        };
}

var Verification = {
  disabledReasonGet: disabledReasonGet$1,
  dueByGet: dueByGet,
  make: make$2
};

var partial_arg$5 = Relude_Option.keep(function (param) {
      return Relude_String.startsWith("acct_", param);
    });

function fromString$2(param) {
  return Relude_Globals.$great$great(Relude_Option.pure, partial_arg$5, param);
}

var include$2 = TypeUtils.MakeCustomOpaqueStringType({
      fromString: fromString$2,
      toString: Relude_Globals.id
    });

var fromString$3 = include$2.fromString;

var toString = include$2.toString;

function toStripeUrl(param) {
  return Relude_Globals.$great$great(toString, (function (param) {
                return "https://dashboard.stripe.com/connect/accounts/" + param;
              }), param);
}

function parse(param) {
  return Relude_Globals.$great$great(fromString$3, Relude_Option.getOrThrow, param);
}

var GraphQL_API = {
  parse: parse,
  serialize: toString
};

var Id_decode = include$2.decode;

var Id_encode = include$2.encode;

var Id_compare = include$2.compare;

var Id_eq = include$2.eq;

var Id_Ord = include$2.Ord;

var Id_Set = include$2.$$Set;

var Id_Map = include$2.$$Map;

var Id = {
  fromString: fromString$3,
  toString: toString,
  decode: Id_decode,
  encode: Id_encode,
  compare: Id_compare,
  eq: Id_eq,
  Ord: Id_Ord,
  $$Set: Id_Set,
  $$Map: Id_Map,
  toStripeUrl: toStripeUrl,
  GraphQL_API: GraphQL_API
};

function make$3(prim) {
  return {
          data: prim
        };
}

var partial_arg$6 = Curry._1(Relude_Array.find, hasInstantPay);

function partial_arg$7(param) {
  return Relude_Globals.$great$great((function (prim) {
                return prim.data;
              }), partial_arg$6, param);
}

function hasInstantPay$1(param) {
  return Relude_Globals.$great$great(partial_arg$7, Relude_Option.isSome, param);
}

var ExternalAccounts = {
  make: make$3,
  hasInstantPay: hasInstantPay$1
};

function make$4(prim, prim$1, prim$2, prim$3, prim$4) {
  var tmp = {
    id: prim,
    external_accounts: prim$1
  };
  if (prim$2 !== undefined) {
    tmp.requirements = Caml_option.valFromOption(prim$2);
  }
  if (prim$3 !== undefined) {
    tmp.verification = Caml_option.valFromOption(prim$3);
  }
  return tmp;
}

function hasInstantPay$2(param) {
  return Relude_Globals.$great$great((function (prim) {
                return prim.external_accounts;
              }), hasInstantPay$1, param);
}

var Account = {
  Requirements: Requirements,
  Verification: Verification,
  Id: Id,
  ExternalAccounts: ExternalAccounts,
  make: make$4,
  hasInstantPay: hasInstantPay$2
};

function make$5(currency) {
  return function (param) {
    return function (param$1) {
      return {
              amount: param,
              currency: currency,
              source_types: param$1
            };
    };
  };
}

function currencyGet(param) {
  return Relude_Globals.$great$great((function (prim) {
                return prim.currency;
              }), currencyFromJs$1, param);
}

var BalanceHash = {
  make: make$5,
  currencyGet: currencyGet
};

function make$6(prim, prim$1) {
  return {
          available: prim,
          pending: prim$1
        };
}

var Balance = {
  BalanceHash: BalanceHash,
  make: make$6
};

var Id$1 = TypeUtils.MakeOpaqueStringType({});

function make$7(arrivalDate, created) {
  var arg = StripeTypes_Utils.dateToFloat(arrivalDate);
  var arg$1 = StripeTypes_Utils.dateToFloat(created);
  return function (param) {
    return function (param$1) {
      var func = function (param$2, param$3, param$4, param$5, param$6, param$7, param$8, param$9, param$10, param$11) {
        return {
                id: param,
                object: param$1,
                amount: param$2,
                arrival_date: param$3,
                automatic: param$4,
                balance_transaction: param$5,
                created: param$6,
                currency: param$7,
                description: param$8,
                destination: param$9,
                method: param$10,
                status: param$11
              };
      };
      return function (param) {
        var func$1 = Curry._2(func, param, arg);
        return function (param) {
          var func$2 = Curry._1(func$1, param);
          return function (param) {
            return Curry._2(func$2, param, arg$1);
          };
        };
      };
    };
  };
}

function arrivalDateGet(param) {
  return Relude_Globals.$great$great((function (prim) {
                return prim.arrival_date;
              }), StripeTypes_Utils.floatToDate, param);
}

function createdGet(param) {
  return Relude_Globals.$great$great((function (prim) {
                return prim.created;
              }), StripeTypes_Utils.floatToDate, param);
}

function paymentMethodGet(param) {
  return Relude_Globals.$great$great((function (prim) {
                return prim.method;
              }), tFromJs$1, param);
}

function currencyGet$1(param) {
  return Relude_Globals.$great$great((function (prim) {
                return prim.currency;
              }), currencyFromJs$1, param);
}

function statusGet(param) {
  return Relude_Globals.$great$great((function (prim) {
                return prim.status;
              }), payoutStatusFromJs$1, param);
}

function currencyGet$2(param) {
  return Relude_Globals.$great$great((function (prim) {
                return prim.currency;
              }), currencyFromJs$1, param);
}

function paymentMethodGet$1(param) {
  return Relude_Globals.$great$great((function (prim) {
                return prim.method;
              }), tFromJs$1, param);
}

function make$8(currencyOpt, paymentMethod) {
  var currency = currencyOpt !== undefined ? currencyOpt : "usd";
  return function (param) {
    return function (param$1) {
      return {
              amount: param,
              currency: currency,
              method: paymentMethod,
              source_type: param$1
            };
    };
  };
}

var Payload = {
  currencyGet: currencyGet$2,
  paymentMethodGet: paymentMethodGet$1,
  make: make$8
};

function make$9(prim) {
  return {
          id: prim
        };
}

var $$Response = {
  make: make$9
};

var Create = {
  Payload: Payload,
  $$Response: $$Response
};

var ArrivalDate = {};

var Created = {};

function make$10(prim, prim$1, prim$2, prim$3, prim$4, prim$5) {
  var tmp = {};
  if (prim !== undefined) {
    tmp.arrival_date = Caml_option.valFromOption(prim);
  }
  if (prim$1 !== undefined) {
    tmp.created = Caml_option.valFromOption(prim$1);
  }
  if (prim$2 !== undefined) {
    tmp.destination = Caml_option.valFromOption(prim$2);
  }
  if (prim$3 !== undefined) {
    tmp.limit = Caml_option.valFromOption(prim$3);
  }
  if (prim$4 !== undefined) {
    tmp.status = Caml_option.valFromOption(prim$4);
  }
  return tmp;
}

var Payload$1 = {
  make: make$10
};

function make$11(prim) {
  return {
          data: prim
        };
}

var $$Response$1 = {
  make: make$11
};

var List = {
  ArrivalDate: ArrivalDate,
  Created: Created,
  Payload: Payload$1,
  $$Response: $$Response$1
};

var Payout = {
  Id: Id$1,
  make: make$7,
  arrivalDateGet: arrivalDateGet,
  createdGet: createdGet,
  paymentMethodGet: paymentMethodGet,
  currencyGet: currencyGet$1,
  statusGet: statusGet,
  Create: Create,
  List: List
};

function make$12(prim) {
  return {
          url: prim
        };
}

var LoginLink = {
  make: make$12
};

var include$3 = TypeUtils.MakeOpaqueStringType({});

var fromString$4 = include$3.fromString;

var toString$1 = include$3.toString;

function toStripeUrl$1(param) {
  return Relude_Globals.$great$great(toString$1, (function (param) {
                return "https://dashboard.stripe.com/connect/transfers/" + param;
              }), param);
}

function parse$1(param) {
  return Relude_Globals.$great$great(fromString$4, Relude_Option.getOrThrow, param);
}

var GraphQL_API$1 = {
  parse: parse$1,
  serialize: toString$1
};

var Id_decode$1 = include$3.decode;

var Id_encode$1 = include$3.encode;

var Id_compare$1 = include$3.compare;

var Id_eq$1 = include$3.eq;

var Id_Ord$1 = include$3.Ord;

var Id_Set$1 = include$3.$$Set;

var Id_Map$1 = include$3.$$Map;

var Id$2 = {
  fromString: fromString$4,
  toString: toString$1,
  decode: Id_decode$1,
  encode: Id_encode$1,
  compare: Id_compare$1,
  eq: Id_eq$1,
  Ord: Id_Ord$1,
  $$Set: Id_Set$1,
  $$Map: Id_Map$1,
  toStripeUrl: toStripeUrl$1,
  GraphQL_API: GraphQL_API$1
};

function currencyGet$3(param) {
  return Relude_Globals.$great$great((function (prim) {
                return prim.currency;
              }), currencyFromJs$1, param);
}

function make$13(currencyOpt) {
  var currency = currencyOpt !== undefined ? currencyOpt : "usd";
  return function (param) {
    return function (param$1, param$2, param$3) {
      return {
              amount: param,
              currency: currency,
              destination: param$1,
              transfer_group: param$2,
              source_type: param$3
            };
    };
  };
}

var Payload$2 = {
  currencyGet: currencyGet$3,
  make: make$13
};

function make$14(prim) {
  return {
          id: prim
        };
}

var $$Response$2 = {
  make: make$14
};

var Create$1 = {
  Payload: Payload$2,
  $$Response: $$Response$2
};

var Transfer = {
  Id: Id$2,
  Create: Create$1
};

var Id$3 = TypeUtils.MakeOpaqueStringType({});

var _map$3 = {"succeeded":"succeeded","failed":"failed","pending":"pending"};

function tToJs$1(param) {
  return param;
}

function tFromJs$2(param) {
  return _map$3[param];
}

function tFromJs$3(param) {
  return Relude_Globals.$great$great(StringUtils.toLowerCase, tFromJs$2, param);
}

function toCommonStatus(param) {
  if (param === "succeeded") {
    return /* Succeeded */2;
  } else if (param === "pending") {
    return /* Pending */0;
  } else {
    return /* Failed */1;
  }
}

var Status = {
  tToJs: tToJs$1,
  tFromJs: tFromJs$3,
  toCommonStatus: toCommonStatus
};

function currencyGet$4(param) {
  return Relude_Globals.$great$great((function (prim) {
                return prim.currency;
              }), currencyFromJs$1, param);
}

function make$15(currencyOpt) {
  var currency = currencyOpt !== undefined ? currencyOpt : "usd";
  return function (param) {
    return function (param$1, param$2) {
      return {
              amount: param,
              currency: currency,
              customer: param$1,
              transfer_group: param$2
            };
    };
  };
}

var Payload$3 = {
  currencyGet: currencyGet$4,
  make: make$15
};

function statusGet$1(param) {
  return Relude_Globals.$great$great((function (prim) {
                return prim.status;
              }), tFromJs$3, param);
}

function make$16(status) {
  return function (param) {
    return function (param$1) {
      return {
              amount: param,
              id: param$1,
              status: status
            };
    };
  };
}

var $$Response$3 = {
  statusGet: statusGet$1,
  make: make$16
};

var Create$2 = {
  Payload: Payload$3,
  $$Response: $$Response$3
};

function statusGet$2(param) {
  return Relude_Globals.$great$great((function (prim) {
                return prim.status;
              }), tFromJs$3, param);
}

function make$17(status) {
  return function (param) {
    return {
            id: param,
            status: status
          };
  };
}

var Charge = {
  Id: Id$3,
  Status: Status,
  Create: Create$2,
  statusGet: statusGet$2,
  make: make$17
};

var Id$4 = TypeUtils.MakeOpaqueStringType({});

var _map$4 = {"canceled":"canceled","failed":"failed","pending":"pending","reversed":"reversed","succeeded":"succeeded"};

function tToJs$2(param) {
  return param;
}

function tFromJs$4(param) {
  return _map$4[param];
}

function tFromJs$5(param) {
  return Relude_Globals.$great$great(StringUtils.toLowerCase, tFromJs$4, param);
}

var Status$1 = {
  tToJs: tToJs$2,
  tFromJs: tFromJs$5
};

function currencyGet$5(param) {
  return Relude_Globals.$great$great((function (prim) {
                return prim.currency;
              }), currencyFromJs$1, param);
}

function make$18(currencyOpt) {
  var currency = currencyOpt !== undefined ? currencyOpt : "usd";
  return function (param) {
    return function (param$1, param$2) {
      return {
              amount: param,
              currency: currency,
              description: param$1,
              statement_descriptor: param$2
            };
    };
  };
}

var Payload$4 = {
  currencyGet: currencyGet$5,
  make: make$18
};

function statusGet$3(param) {
  return Relude_Globals.$great$great((function (prim) {
                return prim.status;
              }), tFromJs$5, param);
}

function make$19(status) {
  return function (param) {
    return function (param$1) {
      return {
              amount: param,
              id: param$1,
              status: status
            };
    };
  };
}

var $$Response$4 = {
  statusGet: statusGet$3,
  make: make$19
};

var Create$3 = {
  Payload: Payload$4,
  $$Response: $$Response$4
};

function statusGet$4(param) {
  return Relude_Globals.$great$great((function (prim) {
                return prim.status;
              }), tFromJs$5, param);
}

function make$20(status) {
  return function (param) {
    return {
            id: param,
            status: status
          };
  };
}

var Topup = {
  Id: Id$4,
  Status: Status$1,
  Create: Create$3,
  statusGet: statusGet$4,
  make: make$20
};

function make$21(prim, prim$1, prim$2, prim$3, prim$4) {
  var tmp = {};
  if (prim !== undefined) {
    tmp.api_key = Caml_option.valFromOption(prim);
  }
  if (prim$1 !== undefined) {
    tmp.idempotency_key = Caml_option.valFromOption(prim$1);
  }
  if (prim$2 !== undefined) {
    tmp.stripe_account = Caml_option.valFromOption(prim$2);
  }
  if (prim$3 !== undefined) {
    tmp.stripe_version = Caml_option.valFromOption(prim$3);
  }
  return tmp;
}

var SuperSecretStripeOptions = {
  make: make$21
};

var Customer;

exports.Customer = Customer;
exports.$$Error = $$Error;
exports.Key = Key;
exports.PublicKey = PublicKey;
exports.currencyToJs = currencyToJs;
exports.currencyFromJs = currencyFromJs$1;
exports.payoutStatusToJs = payoutStatusToJs;
exports.payoutStatusFromJs = payoutStatusFromJs$1;
exports.PayoutMethod = PayoutMethod;
exports.ExternalAccount = ExternalAccount;
exports.Account = Account;
exports.Balance = Balance;
exports.Payout = Payout;
exports.LoginLink = LoginLink;
exports.Transfer = Transfer;
exports.Charge = Charge;
exports.Topup = Topup;
exports.SuperSecretStripeOptions = SuperSecretStripeOptions;
/* include Not a pure module */
